import React from 'react';
import _, { cloneDeep } from 'lodash';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { compose } from 'redux';



function withPlanning (WrappedComponent) {
    class WithPlanning extends React.Component {
        static propTypes = {
            activeLayers: PropTypes.array,
            currentPlanningAlert: PropTypes.object,
            // Redux state
            enabled: PropTypes.bool.isRequired,
            areaFacet: PropTypes.object,
            areaFacetValue: PropTypes.string,
            areaFacetValid: PropTypes.bool,
            currentPlanningReport: PropTypes.object,
            planningLayer: PropTypes.object,

            highlightedFeatures: PropTypes.array.isRequired
        };

        static defaultProps = {
            activeLayers: []
        };

        render () {
            const { activeLayers, enabled, currentPlanningAlert, currentPlanningReport, planningLayer, areaFacet, areaFacetValue, areaFacetValid, highlightedFeatures, ...props } = this.props;
            const newActiveLayers = [...activeLayers];

            if (enabled) {

                // If search area is valid and is fixed (references a layer) then load tiles for that layer
                if (areaFacet && areaFacet.layerType === 'fixed' && areaFacetValid) {
                    newActiveLayers.push({
                        uid: 'planning_alert_area_facet_' + areaFacet.id,
                        systemName: areaFacet.layer.systemName,
                        visible: true,
                        printable: false,
                        layerData: {
                            mvt: true,
                            url: `${areaFacet.layerData.url}?value=${areaFacetValue}`
                        },
                        styling: {
                            'layers': [
                                {
                                    'type': 'fill',
                                    'paint': {
                                        'fill-color': '#A9FE95',
                                        'fill-outline-color': '#A9FE95',
                                        'fill-opacity': 0.2

                                    }
                                },
                                {
                                    'type': 'line',
                                    'layout': {
                                        'line-cap': 'round',
                                        'line-join': 'round'
                                    },
                                    'paint': {
                                        'line-color': '#A9FE95',
                                        'line-dasharray': [0.2, 2],
                                        'line-width': 4
                                    }
                                }
                            ],
                            'source': {
                                'type': 'vector',
                                'maxzoom': 22,
                                'minzoom': 1
                            }
                        },
                        settings: [],
                        primaryKey: 'id',
                        highlights: []
                    });
                }

                if (currentPlanningReport && currentPlanningReport.layerData) {

                    newActiveLayers.push( {
                        uid: `planning_alert_${currentPlanningReport.planningAlertId}`,
                        systemName: 'planning_alert_area',
                        visible: true,
                        printable: false,
                        layerData: {
                            mvt: currentPlanningReport.layerData.mvt,
                            url: currentPlanningReport.layerData.areaUrl
                        },
                        styling: {
                            'layers': [
                                {
                                    'type': 'fill',
                                    'paint': {
                                        'fill-color': '#A9FE95',
                                        'fill-outline-color': '#A9FE95',
                                        'fill-opacity': 0.2

                                    }
                                },
                                {
                                    'type': 'line',
                                    'layout': {
                                        'line-cap': 'round',
                                        'line-join': 'round'
                                    },
                                    'paint': {
                                        'line-color': '#A9FE95',
                                        'line-dasharray': [0.2, 2],
                                        'line-width': 4
                                    }
                                }
                            ],
                            'source': {
                                'type': 'vector',
                                'maxzoom': 22,
                                'minzoom': 1
                            }
                        },
                        settings: [],
                        primaryKey: 'id',
                        highlights: []
                    });

                    // TODO - make visible from further away, need to deep clone
                    const spec = cloneDeep(planningLayer.styles[0].mapboxStyleSpecification);
                    spec.source.minzoom = 1;

                    newActiveLayers.push({
                        uid: `${planningLayer.system_name}_report_${currentPlanningReport.id}`,
                        systemName: planningLayer.system_name,
                        visible: true,
                        printable: false,
                        layerData: currentPlanningReport.layerData,
                        styling: spec,
                        settings: [],
                        primaryKey: planningLayer.properties.id,
                        highlights: highlightedFeatures.filter(e => e.layerSystemName === planningLayer.system_name)
                    });
                }
            }

            return (
                <WrappedComponent
                    activeLayers={newActiveLayers}
                    {...props}
                />
            );
        }
    }

    const wrappedComponentName = WrappedComponent.displayName
        || WrappedComponent.name
        || 'Component';

    WithPlanning.displayName = `withPlanning(${wrappedComponentName})`;
    return WithPlanning;
}

const mapStateToProps = (state) => {
    const reducer = state.planningReducer;
    const currentPlanningReportId = reducer.currentPlanningReportId;
    const planningAlertForm = reducer.planningAlertForm;
    return {
        enabled: Boolean(state.panels.panels.planningAlerts.enabled),

        areaFacet: state.lookups.uiData.facetChoices.find(el => el.id === planningAlertForm.facetId),
        areaFacetValue: planningAlertForm.facetValue,
        areaFacetValid: planningAlertForm.facetValid,

        currentPlanningReport: reducer.planningReports.find(report => report.id === currentPlanningReportId),
        planningLayer: state.layers.layers.find(layer => layer.id === 145),

        highlightedFeatures: state.highlights.highlightedFeatures
    };
};

export default compose(connect(mapStateToProps, null), withPlanning);